import { grommet, Text } from "grommet";
import { deepMerge } from "grommet/utils";
import { ThemeType } from "grommet/themes";
import React from "react";

const params = new URLSearchParams(window.location.search.toLocaleLowerCase());

const presenceTheme: ThemeType = {
  global: {
    font: {
      size: "16px",
      family: "Magreb",
    },
    colors: {
      /* BEGIN: Color Palette Definition */
      // brand: "var(--accent)",
      "light-1": "#f7f7f7",
      "light-2": "#e1e1e1",
      "light-3": "#b1b1b1",
      "dark-1": "#0c0e12",
      "dark-2": "#212224bf",
      "dark-3": "#3b3b3b",
      /* END: Color Palette Definition */
      /* BEGIN: Mapping Colors to Grommet Namespaces */
      background: {
        dark: "dark-1",
        light: "light-1",
      },
      "background-back": {
        dark: "dark-2",
        light: "light-2",
      },
      "background-front": {
        dark: "dark-3",
        light: "light-3",
      },
      "background-contrast": {
        dark: "light-3",
        light: "dark-3",
      },
      control: {
        dark: "brand",
      },
    },
    focus: {
      border: {
        color: "brand",
      },
    },
    /* END: Mapping Colors to Grommet Namespaces */
  },
  /* BEGIN: Mapping Colors to Components */
  anchor: {
    color: "text",
    hover: {
      textDecoration: "none",
    },
  },
  button: {
    border: {
      radius: "4px",
    },
  },
  grommet: {
    extend: {
      background: params.get("background") || "background-back",
    },
  },
  layer: {
    background: {
      dark: "background",
      light: "background",
    },
  },
  menu: {
    background: {
      dark: "background",
      light: "background",
    },
  },
  tip: {
    content: {
      background: {
        dark: "dark-2",
        light: "light-2",
      },
    },
  },
  // formField: {
  //       label: {
  //           requiredIndicator: (
  //               <Text a11yTitle="required" color="status-critical">
  //                   *
  //               </Text>
  //           ),
  //       },
  //   },
  /* END: Mapping Colors to Components */
};

const Theme = deepMerge(grommet, presenceTheme);

export default Theme;
